export const environment = {
    production: false,
    title:"QA Environment",
    firebase: {
        apiKey: "AIzaSyCnLgrWfucwftXQt5zzFpLStIfkwSM-9E0",
        authDomain: "ole-qms-qa.firebaseapp.com",
        projectId: "ole-qms-qa",
        storageBucket: "ole-qms-qa.appspot.com",
        messagingSenderId: "669626379804",
        appId: "1:669626379804:web:fab027b0cd6fd02f86f9d9",
        measurementId: "G-69HXSZV0E8"
    },
    appTitle: 'OLÉ (qa)',
    api: "https://us-central1-ole-qms-qa.cloudfunctions.net/api-v1"    
    //api: "http://localhost:5000/ole-qms-qa/us-central1/api-v1"
  };